<template>
	<div>
		<header class="lmy-header lmy-header-user">
			我的下级
	        <i class="iconfont icon-yuyin" @click="routetokPage('/user')"></i>
	    </header>
		<div class="user-member-box">
			<!-- <div class="user-info">
				<div class="avatar">
					<img src="./../../../assets/img/userDefaultImg.png" v-if="!userInfo.Avater" alt="">
					<img :src="userInfo.Avater" v-if="userInfo.Avater">
					<span class="tag" v-if="userInfo.IsAgent!='True'">代理</span>

				</div>
				<div class="user">
					<p class="name">{{userInfo.Customer}}</p>
					<p class="number">编号：<span>{{userInfo.CustomerNO}}</span> </p>
				</div>

			</div> -->
			<div class="my-member-box">
				<p>直接下级人数：{{total}}人</p>
				<div class="my-member-list">
					<ul>
						<li v-for="(user,i) in list" :key="i">
							<div class="mml-left">
								<img :src="user.Avatar" v-if="user.Avatar">
								<img src="./../../../assets/img/userDefaultImg.png" v-else alt="">

							</div>
							<div  class="mml-right">
								<h4>{{user.Name}}</h4>
								<h4>{{user.Phone}}(下级人数：{{user.SubCount}}人)</h4>
								<p>{{user.JoinTime|dateLongToYMDline}}</p>
							</div>
						</li>
						<!-- <li >
							<div class="mml-left">
								<img src="./../../../assets/img/userDefaultImg.png" alt="">
							</div>
							<div  class="mml-right">
								<h4>天师</h4>
								<h4>18812345678(下级人数：5人)</h4>
								<p>2019-02-14</p>
							</div>
						</li> -->

					</ul>
				</div>
			</div>
			<infinite-loading @infinite="initData" ref="infiniteLoading">
				<span slot="no-more">
				没有更多了...
				</span>
				<span slot="no-results">
				您暂时没有下级
				</span>
			</infinite-loading>
		</div>

	</div>

</template>
<script>
	import InfiniteLoading from 'vue-infinite-loading';
	export default{
		name:'my-member',
		components:{
			InfiniteLoading,
		},
		data(){
			return{
				userInfo:this.dao.get('userInfo')?JSON.parse(this.dao.get('userInfo')):'',
				list:[],
				total:0,
				Page:1,
				PageSize:10
			}
		},
		methods:{
				 	   //条件更新后重置参数和结果
 			changeFilter($state) {

	 			this.Page=1;
	 			this.total=0;
				this.list=[];
		      	this.$nextTick(() => {
		      	    this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
		      	});
		    },
			initData($state){
				var that=this;
				if(this.total>0&&(((this.Page-1)*this.PageSize)>this.total)){
					$state.complete();
					return;
				}
 		 		var param={
					Page:that.Page,
					PageSize:that.PageSize,
				}
				that.getRequest({
					url:that.Api.getMyMembers,
					params:param
				}).then(res => {
					this.loading=false;
					if (res&&res.IsSuccess&&res.Result.length>0) {
				        that.total=res.Total;
						that.Page+=1;
				        that.list = that.list.concat(res.Result);
				        $state.loaded();

				    } else{
				    	 $state.complete();
				    }
				});
			}

		}
	}
</script>



// WEBPACK FOOTER //
// src/components/usr/myMember/myMember.vue